function AutoScrollBtn({ scrollAt, speed, label, selected, hasSavedPreference }) {
  const renderClass = () => {
    let baseClasses = 'btn';
    if (selected !== null && selected === speed) {
      baseClasses += ' selected';
    }
    if (hasSavedPreference) {
      baseClasses += ' has-preference';
    }
    return baseClasses;
  };

  return (
    <span onClick={() => scrollAt(speed)} className={renderClass()}>
      <span>{label}</span>
    </span>
  );
}

export default AutoScrollBtn;
